import { isMultileg, type Security } from '@talos/kyoko';
import { useCallback } from 'react';
import { MultilegComboType } from '../components/MultilegCombo/enums';
import { getMultilegInstrumentType } from '../components/OMS/NewOrder/utils/mappers';
import { useNavigateToDeepDive } from './useNavigateToDeepDive';
import { useNavigateToMultilegCombo } from './useNavigateToMultilegCombo';

/**
 * Returns a callback that navigates to multileg combo when security is multileg, otherwise to deep dive.
 * Use for DeepDive buttons and similar entry points where the destination depends on security type.
 */
export function useNavigateToDeepDiveOrMultileg() {
  const navigateToDeepDive = useNavigateToDeepDive();
  const navigateToMultilegCombo = useNavigateToMultilegCombo();

  return useCallback(
    (
      security: Security | undefined,
      marketAccountSelections?: string[],
      marketSelections?: string[],
      aggregation?: string
    ) => {
      if (!security) {
        return;
      }
      if (isMultileg(security)) {
        const instrumentType =
          getMultilegInstrumentType(security?.MultilegDetails?.SyntheticProductType) ??
          MultilegComboType.SyntheticCross;
        navigateToMultilegCombo(instrumentType, security);
      } else {
        navigateToDeepDive(security, marketAccountSelections, marketSelections, aggregation);
      }
    },
    [navigateToDeepDive, navigateToMultilegCombo]
  );
}
